<template>
  <div class="SendMessageView">




    <search-form
      :chgDataList="SearchDataList"
      :table-btn-arr="tableBtnArr"
      @handleEvent="btnGroupEvents"
      @handle-search="getReportDataPreviewData2"
      ref="searchForm"
      style="margin-left: 40px"
    >
    </search-form>





    <a-form-model>
      <a-row>

        <a-col :span="24"    >
          <a-form-model-item
            :labelCol="{ span: 1, offset: 0 }"
            :wrapperCol="{ span: 23, offset: 0 }"
            label=" "
            :colon="false"
          >
            <use-table
              :current="page"
              :data="data"
              :tableHeaderModel="tableHeaderModel"
              @rowEvent="rowEvents"
              :totals="total"
              ref="useTable"
              @pagination-event="paginationEvent"

            />
          </a-form-model-item>
        </a-col>

      </a-row>
    </a-form-model>


  </div>
</template>
<script>
import UseTable from "./UseTable";
import province from "@/utils/province.js";
import SearchForm from "@/components/SearchForm.vue";
import SearchNoButtonForm  from "@/components/SearchNoButtonForm.vue";
import {queryRole} from "../../../config/typeConfig";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
// import SearchNoButtonForm from "../../SearchNoButtonForm";

export default {
  name: "SendMessageView",
  data() {
    return {
      rules:{
        title: [
          {
            required: true,
            message: "请输入消息标题",
            trigger: "blur"
          }
        ],
        content: [
          {
            required: true,
            message: "请输入消息内容",
            trigger: "blur"
          }
        ],
        sendType:[
          {
            required: true,
            message: "请选择发送范围",
            trigger: ["change","blur" ]
          }
        ],
      },
      rules2:{

      },
      sendTypelist:[
        {
          status:1,
          title:'按照省份发送'
        },
        {
          status:2,
          title:'按照人员选择'
        },
        {
          status:3,
          title:'录入系统外手机号'
        },
        {
          status:4,
          title:'按照角色发送'
        },
      ],
      provinceList: [],
      cityList: [],
      countyList: [],
      page: 1,
      pageSize: 10,
      total: 0,
      data:[],
      tableBtnArr:[],
      userList:[],
      selectUsers:[],
      SearchDataList: [
        {
          key: "smsMsg",
          title: "短信内容",
          type: "input",
          placeholder: "短信内容",
        },
        {
          key: "smsType",
          title: "短信类型",
          type: "select",
          params: {},
          selectName: "getSmsType",
          placeholder: "短信类型",
        },
        {
          key: "sendstatus",
          title: "发送状态",
          type: "select",
          params: {},
          selectName: "getSendstatus",
          placeholder: "发送状态",
        },{
          key: "mobile",
          title: "手机号",
          type: "input",
          placeholder: "手机号",
        },{
          key: "name",
          title: "接收人姓名",
          type: "input",
          placeholder: "接收人姓名",
        },
      ],
      tableHeaderModel:[
        {
          dataIndex: "orgName",
          title: "所在单位"
        },

        {
          dataIndex: "name",
          title: "姓名"
        },
        {
          dataIndex: "mobile",
          title: "手机号"
        },
        {
          dataIndex: "sendstatus",
          title: "发送状态",
          customRender: function(sendstatus) {
            if (sendstatus == "0") return "待发送";
            if (sendstatus == "1") return "发送成功";
            if (sendstatus == "3") return "发送失败";
          }
        },
        {
          dataIndex: "smsType",
          title: "发送类型",
          customRender: function(smsType) {
            if (smsType == "sysmsg") return "系统通知短信";
            if (smsType == "2") return "验证码";
          }
        },
        {
          dataIndex: "createTime",
          title: "创建时间"
        },

        {
          dataIndex: "sendTime",
          title: "发送时间"
        },
        {
          dataIndex: "smsMsg",
          title: "短信内容"
        },
      ],
      formData:{
        province: undefined,
        city: undefined,
        county: undefined,
      },
      form: {
        sendType:1,
        content:'',
        smsFlag:[0],
        mobiles:''
      },
      rolelist:[]
    };
  },
  components: {
    UseTable,
    SearchForm,
    SearchNoButtonForm
  },
  mounted() {
    this.fetchData();
    this.getRoleData();
  },
  computed: {
    ...mapState(["tableSelected", "tableSelectArr"])
  },
  methods:{
    handleSearch(){
      this.getReportDataPreviewData2()
    },
    handleReset(){
      const refs = this.$refs.queryForm;
      refs.resetFields();
      this.getReportDataPreviewData2()
    },



    ChangeSend(val){
      console.log(val)
    },

    // 表格操作按钮组事件
    btnGroupEvents(methodName) {
      this[methodName]();
    },

    getRoleData(){
      queryRole(this,{}).then((data)=>{
        if(data){
          this.rolelist = data;
        }
      })
    },

    getReportDataPreviewData2(formData = this.formData,page = 1) {
      this.page = page;
      this.formData = formData;

      let params = {
        urlName: "querySms",
        params: {
          pageNo: this.page,
          pageSize: this.pageSize
        }
      };
      this.formData.pageNo = this.page;
      this.formData.pageSize = this.pageSize;
      params.params = this.formData;
      this.getTableData(params.params);
    },
    // 表格行操作按钮组事件
    rowEvents(obj) {
      this[obj.method](obj.row, obj.num);

    },

    getTableData(params = this.formData) {
      const uri = "querySms";
      this.$json(uri, params).then(response => {
        let data = response.record;
        this.total = response.total;
        this.data = data;
      }).catch(e => {
        this.$message.error(e.message);
      });
    },
    getSelectRows(selectRows){
      this.selectUsers = selectRows;


    },
    handleSelect(){
      // this.userList.push();
      this.$refs.useTable.tableSelectArr.map(item => {
        console.log("ITEM="+item);
        this.data.map(ditem=>{
          if(ditem.id == item){
            if(!this.userList.includes(ditem)){
              if( this.userList.length >0) {
                this.userList.push(ditem);
                this.form.selUsers.push(ditem.id);

                // this.userList.push(item.name + "-" + item.phone);
                // this.form.selUsers.push(item.name + "-" + item.phone);
              }else{
                this.userList= [ditem];
                this.form.selUsers=[ditem.id];
                // this.userList= [item.name + "-" + item.phone];
                // this.form.selUsers=[item.name + "-" + item.phone];
              }
            }
          }
        })
        // if(!this.userList.includes(item)){
        //   if( this.userList.length >0) {
        //     this.userList.push(item);
        //     this.form.selUsers.push(item);
        //
        //     // this.userList.push(item.name + "-" + item.phone);
        //     // this.form.selUsers.push(item.name + "-" + item.phone);
        //   }else{
        //     this.userList= [item];
        //     this.form.selUsers=[item];
        //     // this.userList= [item.name + "-" + item.phone];
        //     // this.form.selUsers=[item.name + "-" + item.phone];
        //   }
        // }

      });
    },
    fetchData() {
      province.getProvinceBasic(this).then(res => {
        this.provinceList = res;
      });
      this.getReportDataPreviewData2();
    },
    // 分页事件
    paginationEvent(arr) {
      // const aa="";
      this.page = arr.page;
      this.pageSize = arr.pageSize;
      this.getReportDataPreviewData2(this.formData,arr.page);

      this.$refs.useTable.selectRows=[];
    },
    provinceHandleChange(val) {
      this.formData.city = undefined;
      this.formData.county = undefined;
      if (this.formData.province != undefined) {
        this.queryArea(val, "city");
      }
    },
    cityHandleChange(val) {
      this.form.county = undefined;
      if (this.form.city != undefined) {
        this.queryArea(val, "county");
      }
    },
    countyHandleChange(val) {},
    queryArea(parentId, type) {
      let orgType = 4;
      if ("city" == type) {
        orgType = 3;
      } else if ("county" == type) {
        orgType = 2;
      }
      const query = {
        url: "queryBaseOrgBasic",
        params: {
          parentId: parentId,
          orgType: orgType
        }
      };
      this.$json(query.url, query.params).then(res => {
        const data = res.record;
        if ("city" == type) {
          this.cityList = data;
        } else if ("county" == type) {
          this.countyList = data;
        }
      });
    },
  }
}
</script>

<style scoped>

.textarea{
  font-size: 12px;
  text-align: right;
  margin-top: -15px;
  margin-right: 15px;
}

</style>



// WEBPACK FOOTER //
// src/components/layout/header/SendMessageView.vue